import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";
import { DateTime } from "luxon";

export const createSlotInitialValues = {
  userId: undefined,
  name: "",
  description: "",
  roomId: undefined,
  expectedAttendance: undefined,
  color: "",
  dateStart: "",
  dateEnd: "",
  startTime: undefined,
  duration: 45,
  fees: "",
  capacity: undefined,
  days: [],
  price: 0,
  currency: "EUR",
  checkedToggle: false,
};

export const createSlotNewInitialValues = {
  date_end: "",
  date_start: "",
  slot_bond_group_ids: "",
  fee_ids: "",
  day: "",
  days: [],
  slot_place_id: undefined,
  duration: 45,
  price: undefined,
  type_slot: false,
  start_time: "",
};

export const createSlotNewValidationSchema = Yup.object({
  date_end: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  date_start: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  slot_bond_group_ids: Yup.string().optional(),
  fee_ids: Yup.string().optional(),
  days: Yup.array().min(1, null).required(FIELD_REQUIRED_MESSAGE),
  slot_place_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  duration: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  day: Yup.string().optional(),
  price: Yup.string().when("type_slot", {
    is: true,
    then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
    otherwise: (schema) => schema.optional(),
  }),

  type_slot: Yup.boolean().required(FIELD_REQUIRED_MESSAGE),
  start_time: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});

export const createSlotValidationSchema = Yup.object({
  userId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  roomId: Yup.number().optional(),
  expectedAttendance: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  startTime: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  duration: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  fees: Yup.string(),
  capacity: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  days: Yup.array().required(FIELD_REQUIRED_MESSAGE),

  price: Yup.number().when(
    "checkedToggle",
    (checkedBonosValue: any, schema: Yup.NumberSchema) => {
      return checkedBonosValue === false
        ? schema.required(FIELD_REQUIRED_MESSAGE)
        : schema.optional();
    }
  ),
  currency: Yup.string().when(
    "checkedToggle",
    (checkedBonosValue: any, schema: Yup.StringSchema) => {
      return checkedBonosValue === false
        ? schema.required(FIELD_REQUIRED_MESSAGE)
        : schema.optional();
    }
  ),
});

export const editSlotValidationSchema = Yup.object({
  userId: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  roomId: Yup.number().optional(),
  expectedAttendance: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  color: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  startTime: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  duration: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  fees: Yup.string(),
  capacity: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  days: Yup.array().required(FIELD_REQUIRED_MESSAGE),

  price: Yup.number().when(
    "checkedToggle",
    (checkedBonosValue: any, schema: Yup.NumberSchema) => {
      return checkedBonosValue === false
        ? schema.required(FIELD_REQUIRED_MESSAGE)
        : schema.optional();
    }
  ),
  currency: Yup.string().when(
    "checkedToggle",
    (checkedBonosValue: any, schema: Yup.StringSchema) => {
      return checkedBonosValue === false
        ? schema.required(FIELD_REQUIRED_MESSAGE)
        : schema.optional();
    }
  ),
});

export type CreateSlotValues = typeof createSlotValidationSchema;

export const slotsTimesInitialValues = {
  hours: undefined,
};

export const slotsTimesValidationSchema = Yup.object({
  hours: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

export type SlotsTimesValues = typeof slotsTimesInitialValues;

export const holidaysInitialValues = {
  description: "",
  type: "Local",
  date: "",
  time_start: "00:00",
  time_end: "23:59",
};

export const holidaysValidationSchema = Yup.object({
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  type: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  date: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  time_start: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  time_end: Yup.string().required(FIELD_REQUIRED_MESSAGE),
});
